export enum TaskSubType {
  WORK = 'WORK',
  DELIVERY = 'DELIVERY',
  INSPECTION = 'INSPECTION',
  ROADBLOCK = 'ROADBLOCK',
  SAFETY = 'SAFETY',
  DOWNTIME = 'DOWNTIME',
}
